import cxs from 'cxs';

export const LIST_CONTAINER = (
{ loading, isMobile }) =>
cxs({
  height: '100%',
  flex: loading ? 1 : 'initial',

  ...(isMobile ?
  {
    ' .list-container__content__item > .check-box': {
      height: '20px',
      minHeight: '20px',
      minWidth: '20px',
      width: '20px',
      marginRight: '10px'
    }
  } :
  {})

});

export const CARDS_GRID = ({ isMobile }) => cxs({
  display: 'grid',
  justifyContent: isMobile ? 'center' : 'flex-start',
  gridColumnGap: '20px',
  gridRowGap: '20px',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gridAutoRows: 'minmax(250px, max-content)'
});